import styled from 'styled-components/macro'

export const Layout = styled.div`
  padding: 0 0 6.4rem 0;
  height: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    'Header'
    'Main'
    'Footer';
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 0;
  `};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    grid-template-columns: 30.1rem 1fr;
    grid-template-areas:
    'Header Header'
    'Aside Main'
    'Footer Footer';
  `};
`
